// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

/* 模板管理：预先获取模板下标 */
import { fetchTemplateIndexFromICP } from './config/templates'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});

// 等待接口完成后再创建 Vue 实例并渲染
(async function initApp() {
  // 在浏览器环境中，等待接口完成获取模板下标
  if (typeof window !== 'undefined') {
    try {
      await fetchTemplateIndexFromICP();
      console.log('Template index fetched, starting Vue app...');
    } catch (error) {
      console.error('Failed to fetch template index, using fallback:', error);
      // 即使接口失败，也继续启动应用（使用域名 hash 作为后备方案）
    }
  }

  // 接口完成后，创建并挂载 Vue 实例
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  });
})();



// WEBPACK FOOTER //
// ./src/main.js